import React, { Component } from "react";
import { connect } from 'react-redux';
import Swal from 'sweetalert2'
import { NavigationHeader } from "../../layout/components/navigationheader/NavigationHeader";
import { Card, Button, Row, Col, Form } from 'react-bootstrap';
import { updateRequestUrl } from '../../../../../../../actions/sceneActions'
import { URL_SUCCESS_SAVE, SUCCESS_TEXT } from '../../../app/messageText'
import { validURL, updateURLForIframe, customClass, getInitialRoute } from '../../../../../../../utils'
import { CloudUrlStudio } from  "../../../../../../../actions/api";

class UpdateLinks extends Component {
    state = {
        url: null,
        buttonDis : false,
        loader:false,
        errorLink: null,
    }
    componentDidMount() {
        const { match, scenes, history } = this.props;
        if (scenes.updateSceneData && Object.keys(scenes.updateSceneData).length > 0) {
            this.setState({ url: scenes.updateSceneData.content })
        }
        else history(`/studio/${match.params.wallId}`)
    }


    onTextUrl = (event) => {
        var enterUrl = event.target.value; 
        if (window.location.toString().includes("youtube")) {
          if (enterUrl.includes("youtu.be")) {
            enterUrl = enterUrl.replace("youtu.be/", "www.youtube.com/watch?v=");
            this.setState({ url: enterUrl, errorLink: null });
          } else if (enterUrl.includes("youtube")) {
            this.setState({ url: enterUrl, errorLink: null });
          } else {
            this.setState({ url: null, errorLink: 'youtube' });
          }
        } else if (window.location.toString().includes("vimeo")) {
          if (enterUrl.includes("vimeo")) {
            this.setState({ url: enterUrl, errorLink: null });
          } else {
            this.setState({ url: null, errorLink: 'vimeo' });
          }
        } else {
          if (enterUrl.includes("https://")) {
            this.setState({ url: enterUrl, errorLink: null });
          } else {
            this.setState({ url: null, errorLink: 'link' });
          }
        }
      };
  

    onSaveUrl = event => {
        const { param } = this.props;
        const { url,errorLink } = this.state;
        const valid_URL = validURL(url) 

        if (url && url != null && url.length > 0 && valid_URL){ 
         if(!errorLink){   
        this.setState({buttonDis:true, loader:true })
        this.props.updateRequestUrl(param.contentMixId, this.props.scenes.updateSceneData.id, url, this.onSaveCallBack)
            
            }else{

            Swal.fire({
                title: "Error",
                text: `${errorLink=='youtube' ? 'Please enter only youtube url!' : errorLink=='vimeo' ? 'Please enter only vimeo url!' : 'Please enter correct url!'}`,
                type: "error",
                icon: "error",
                showConfirmButton: false,
                timer: 3000
            })
         }
        }else{
            Swal.fire({
                title: 'Error',
                text: 'Please enter correct url!',
                type: "error",
                icon: 'error',
                showConfirmButton: false,
                timer: 3000
            })
        }
    }
    
    onBack = event => {
        const { params } = this.props.match;
        Swal.fire({
            title: "Are you sure?",
            text: "Your changes have not been saved. Do you want to save before you leave the page?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Save",
            cancelButtonText: "Discard Changes",
            reverseButtons: true,
            customClass: customClass
        }).then((result) => {
            if (result.value) {
                const { param } = this.props;
                const { url } = this.state;
                const valid_URL = validURL(url)
                if (url && url != null && url.length > 0 && valid_URL){
                    this.setState({buttonDis:true, loader:true })
                    this.props.updateRequestUrl(param.contentMixId, this.props.scenes.updateSceneData.id, url, this.onSaveCallBack)
                    }else {
                    Swal.fire({
                        title: 'Error',
                        text: 'Please enter correct url!',
                        type: "error",
                        icon: 'error',
                        showConfirmButton: false,
                        timer: 3000
                    })
                }
            } else if (result.dismiss === "cancel") {
                this.props.history(`/studio/${params.wallId}`)
            }
        });
    }
    onSaveCallBack = () => {
        
        const { params } = this.props.match;
        Swal.fire({
            title: SUCCESS_TEXT,
            text: URL_SUCCESS_SAVE,
            type: "success",
            icon: 'success',
            showConfirmButton: false,
            timer: 3000
        }
        ).then((result) => {
            this.setState({buttonDis:false, loader:false })
            this.props.history(`/studio/${params.wallId}`)
        })

    }

    render() {
        const { match } = this.props;
        const { url,buttonDis,loader,errorLink } = this.state;
        let GET_TEXT = "Url";
        if (match.url) {
            if (match.url.includes("vimeo")) {
                GET_TEXT = "Vimeo Url";
            }
            else if (match.url.includes("youtube")) {
                GET_TEXT = "YouTube Url";
            }
            else {
                GET_TEXT = "Url";
            }
        }
        return (<>
            <NavigationHeader name={GET_TEXT} backToNavigation={`/studio/${match.params.wallId}`} />
            <div className="container-fluid subheader_content">
                <Card className="select_wall mb-3 rounded-0 border-0">
                    <Card.Body className="p-0">
                        <Row>
                            <Col lg={4} className="border-right-lg">
                                <Card className="border-0 rounded-0">
                                    <Card.Body className="p-4 card_height">
                                        <Form>
                                            <Form.Group controlId="formBasicEmail">
                                                <Form.Label>Enter {GET_TEXT}</Form.Label>
                                                <Form.Control type="text" value={url} className="text-url-update" onChange={this.onTextUrl} placeholder={`Enter ${GET_TEXT} `} />
                                            </Form.Group>
                                        </Form>
                                    </Card.Body>
                                    <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-4">
                                        <button className="btn btn-outline-dark me-3 btn-min-w" onClick={this.onBack}><span className="position-relative">Back</span></button>
                                        <Button disabled={ buttonDis } variant="primary" className={`btn btn-primary btn-min-w ${loader ? `spinner spinner-white spinner-right disabled` : null}`} onClick={this.onSaveUrl}>Save</Button>
                                    </Card.Footer>
                                </Card>
                            </Col>
                            <Col lg={8} className="d-flex align-items-center justify-content-center">
                                <Card className="border-0 card w-100">
                                    <Card.Body className="border-0">
                                        <div className="wall_view">

                                          { !errorLink  ?   
                                            <div className="wall_view_wrapper">
                                                {
                                                    url != null && validURL(url) ? <iframe className="preview-display-wall" src={updateURLForIframe(url)} style={{ maxWidth: '100%', maxHeight: '100%', display: 'block' }}></iframe> : <img src={`${CloudUrlStudio}/images/hero-image.png`} style={{ maxWidth: '100%', maxHeight: '100%', display: 'block' }} />
                                                }
                                            </div> : <div className="wall_view_wrapper studio-prieview">
                                                      { errorLink=='youtube' ? 'Please enter only youtube url!' : errorLink=='vimeo' ? 'Please enter only vimeo url!' : 'Please enter correct url!'}
                                                   </div>  }
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                    </Card.Body>
                </Card>
            </div>
        </>);
    }
}
const mapStateToProps = state => {
    return {
        scenes: state.scene,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        updateRequestUrl: (contentMixId, positionID, url, callBack) => dispatch(updateRequestUrl(contentMixId, positionID, url, callBack)),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(UpdateLinks);